/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { isAzurePlusUser } from '@/lib/marketPlace'
import { getConfigForKey } from '@/store'

import type { UserProfile } from '@/types'

export const shouldShowOrganization = (profile: UserProfile | null): boolean => {
  // Organizations are still not supported by ESSP and Heroku
  const isPrivate = getConfigForKey(`APP_FAMILY`) === `essp`
  const isHeroku = getConfigForKey(`APP_FAMILY`) === `heroku`

  if (isPrivate || isHeroku) {
    return false
  }

  if (!profile) {
    return false
  }

  // Azure++ users can't invite organization members through ESS
  if (isAzurePlusUser(profile)) {
    return false
  }

  return true
}
